import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=05a70c18&scoped=true&"
import script from "./ToDoList.vue?vue&type=script&lang=js&"
export * from "./ToDoList.vue?vue&type=script&lang=js&"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=05a70c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a70c18",
  null
  
)

export default component.exports